import API from "../../api/Routes";
import ACTION from "../../actions";
import { API_URL } from "../../config";
import { showErrorToast, showSuccessToast } from "../../utils/Functions";
import ApiServices from "../../services/Api.services";
import { toast } from "react-toastify";
import swal from "sweetalert";
/******************* 
@Purpose : Used add Comment in the documents 
@Parameter : payload
@Author : INIC
******************/
export const addOfferCandidateComment = (payload) => async (dispatch) => {
  try {
    const response = await ApiServices.postApi(
      API_URL + API.OFFERDOCUMENT_DISCUSSION_CANDIDATE_COMMENT,
      payload
    );
    if (response.data.status === 1) {
      dispatch({
        type: ACTION.OFFER_ACTION_DISCUSSION_CANDIDATE_COMMENT,
        addOfferDiscussionComment: response.data,
      });
      showSuccessToast(response.message);
    } else if (response.data.status === 0) {
      toast.error(response.message);
    }
  } catch (error) {
    showErrorToast(error);
  }
};
/******************* 
@Purpose : Used edit Comment in the documents 
@Parameter : payload
@Author : INIC
******************/
export const editOfferCandidateComment = (payload) => async (dispatch) => {
  try {
    const response = await ApiServices.postApi(
      API_URL + API.OFFERDOCUMENT_DISCUSSION_CANDIDATE_COMMENT,
      payload
    );
    if (response.data.status === 1) {
      dispatch({
        type: ACTION.OFFER_ACTION_DISCUSSION_CANDIDATE_EDIT_COMMENT,
        editOfferCandidateComment: response.data,
      });
      showSuccessToast(response.message);
    } else if (response.data.status === 0) {
      toast.error(response.message);
    }
  } catch (error) {
    showErrorToast(error);
  }
};
/******************* 
@Purpose : Used to get the comment 
@Parameter : payload
@Author : INIC
******************/
export const offerCandidateCommentListing = (payload) => async (dispatch) => {
  try {
    await ApiServices.getApi(
      API_URL +
        API.OFFERDOCUMENT_DISCUSSION_GET_CANDIDATE_COMMENT +
        `?candidateId=` +
        payload.candidateId +
        `&docId=` +
        payload.docId,
      payload
    ).then((response) => {
      dispatch({
        type: ACTION.OFFER_ACTION_DISCUSSION_GET_CANDIDATE_COMMENT,
        offerCommentListing: response.data,
      });
    });
  } catch (error) {
    showErrorToast(error);
  }
};
/******************* 
@Purpose : Used to get the comment 
@Parameter : payload
@Author : INIC
******************/
export const offerdocumentsRequestDocList = (payload) => async (dispatch) => {
  try {
    await ApiServices.getApi(
      API_URL +
        API.OFFERDOCUMENT_DOCUMENTS_SENDREQUESTEDDOC +
        `?candidateId=` +
        payload.candidateId +
        `&requestedBy=` +
        payload.requestedBy,
      payload
    ).then((response) => {
      dispatch({
        type: ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_SENDREQUESTEDDOC,
        offerdocumentsSendRequestDoc: response,
      });
    });
  } catch (error) {
    showErrorToast(error);
  }
};
/******************* 
  @Purpose : Used uploading document 
  @Parameter : payload
  @Author : INIC
  ******************/
export const offerdocumentFileUpload = (payload) => async (dispatch) => {
  try {
    const response = await ApiServices.postApi(
      API_URL + API.OFFERDOCUMENT_DOCUMENTS_FILEUPLOAD,
      payload
    );
    if (response.data.status === 1) {
      dispatch({
        type: ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD,
        payload: response.data,
      });

      showSuccessToast(response.data.message);
    } else if (response.data.status === 0) {
      dispatch({
        type: ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD,
      });
      showErrorToast("File not uploaded");
    } else {
      dispatch({
        type: ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD,
        payload: response.data,
      });
      showSuccessToast(response.data.message);
    }

    return response;
  } catch (error) {
    showErrorToast(error);
  }
};
/******************* 
  @Purpose : Used to edit document
  @Parameter : payload
  @Author : INIC
  ******************/
export const offerdocumentFileUploadEdit = (payload) => async (dispatch) => {
  return swal({
    title: "Are you sure, you want to delete this document?",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  }).then(async (willDelete) => {
    if (willDelete) {
      try {
        const response = await ApiServices.postApi(
          API_URL + API.OFFERDOCUMENT_DOCUMENTS_FILEUPLOAD_EDIT,
          payload
        );
        if (response.status === 1) {
          dispatch({
            type: ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD_EDIT,
            offerdocumentsFileUploadEdit: response.data,
          });
          showSuccessToast(response.data.message);
        } else {
          dispatch({
            type: ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD_EDIT,
            offerdocumentsFileUploadEdit: response.data,
          });
          toast.info(response.data.message);
        }
      } catch (error) {
        showErrorToast(error);
      }
    }
  });
};
